import { Link } from 'gatsby'
import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import {
  NewArrivalsBannerIcon,
  RepairBannerIcon,
  SaleBannerIcon,
  SellBannerIcon,
} from './homepage/HomePageBannerIcons'

const HomeBanner = ({
  url,
  IconComponent,
  iconClassName,
  Image,
  iconColor = 'text-red-600 hover:text-red-800',
}) => {
  return (
    <Link
      to={url}
      className={
        'bg-gray-100 aspect-[2/1] max-w-max h-full duration-200 ease-in grid grid-cols-2 w-full group border-b-4 border-b-transparent hover:border-red-700 ' +
        iconColor
      }
    >
      <div className={iconClassName}>
        <IconComponent />
      </div>

      <div
        className={
          ' flex justify-center items-center overflow-hidden aspect-square  duration-200 px-2'
        }
      >
        {Image}
      </div>
    </Link>
  )
}

HomeBanner.propTypes = {
  url: PropTypes.string.isRequired,
  IconComponent: PropTypes.elementType.isRequired,
  iconClassName: PropTypes.string,
  Image: PropTypes.object,
  imgClassName: PropTypes.string,
}

const WhatWeDo = ({
  orientation = 'horizontal',
  iconColor = 'text-red-600 hover:text-red-800',
}) => {
  return (
    <div
      className={
        (orientation === 'horizontal'
          ? 'grid-cols-2 sm:grid-cols-4 gap-2'
          : 'grid-cols-1 grid-rows-4 gap-4') +
        ' grid max-w-[500px] w-11/12 sm:max-w-[1366px] justify-center items-center py-5 mx-auto'
      }
    >
      <HomeBanner
        url="/what-s-new"
        IconComponent={NewArrivalsBannerIcon}
        iconColor={iconColor}
        iconClassName=""
        Image={
          <StaticImage
            src="../images/new-arrivals.png"
            className=" group-hover:scale-105 duration-200 ease-in"
            alt="New Arrivals Inventory of Used Luxury Watches and Jewelry"
            loading="eager"
            sizes="(max-width: 40em) 17vw, (max-width: 84em) 9vw, 9em"
            breakpoints={[75, 150, 225, 450]}
            width={450}
            placeholder="none"
            aria-label="New Arrivals"
          />
        }
      />
      <HomeBanner
        url="/sale"
        IconComponent={SaleBannerIcon}
        iconColor={iconColor}
        iconClassName=""
        Image={
          <StaticImage
            src="../images/items-on-sale.png"
            className="scale-105 rotate-45 group-hover:scale-110 duration-200 ease-in"
            alt="Pre-owned Luxury Watches and Jewelry On Sale"
            loading="eager"
            sizes="(max-width: 40em) 17vw, (max-width: 84em) 9vw, 9em"
            breakpoints={[75, 150, 225, 450]}
            width={450}
            placeholder="none"
            aria-label="Items On Sale"
          />
        }
      />
      <HomeBanner
        url="/repairs"
        IconComponent={RepairBannerIcon}
        iconColor={iconColor}
        iconClassName=""
        Image={
          <StaticImage
            src="../images/watch-repairs.png"
            className=" group-hover:scale-105 duration-200 ease-in"
            alt="Watch and Jewelry Repair Experts in Miami Beach, Florida"
            loading="eager"
            sizes="(max-width: 40em) 17vw, (max-width: 84em) 9vw, 9em"
            breakpoints={[75, 150, 225, 450]}
            width={450}
            placeholder="none"
            aria-label="Watch Repairs"
          />
        }
      />
      <a
        href="https://sellusyourjewelry.com/"
        target="_blank"
        rel="noopener"
        className={
          'bg-gray-100 aspect-[2/1] max-w-max h-full duration-200 ease-in grid grid-cols-2 w-full group border-b-4 border-b-transparent hover:border-red-700 ' +
          iconColor
        }
      >
        <div className="">
          <SellBannerIcon />
        </div>

        <div
          className={
            ' flex justify-center items-center overflow-hidden aspect-square  duration-200 px-2'
          }
        >
          <StaticImage
            src="../images/sell-trade-consign.png"
            className="group-hover:scale-105 duration-200 ease-in"
            alt="Sell Trade or Consign Rolex, Cartier and Omega Watches and more"
            loading="eager"
            sizes="(max-width: 40em) 17vw, (max-width: 84em) 9vw, 9em"
            breakpoints={[75, 150, 225, 450]}
            width={450}
            placeholder="none"
            aria-label="Sell Trade or Consign"
          />
        </div>
      </a>
    </div>
  )
}

export default WhatWeDo
